import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {DashboardComponent} from './dashboard.component';
import {ProductInsertComponent} from './product-insert.component';
import {ProductsCategoryComponent} from './products-category.component';
import {ProductsListComponent} from './products-list.component';
import {ReceipStock} from './receip-stock.component';
import {IssueStock} from './issue-stock.component';
import {ProductsAbstractComponent} from './products-abstract.component';
import {IssueReceiptStock} from './receipt-issue-stock.component';
import {ReceiptStock2} from './receipt-stock.component_2';
import {IssueStock2} from './issue-stock.component_2';
import {Docket} from './docket.component';
import {SupplierListComponent} from './suppliers-list.component';
import {AuthentificationComponent} from './authentification.component';
import {UsersComponent} from './users.component';
import {SuperUsersComponent} from './super_users.component';
import {SuperUsersAuthentificationComponent} from './super_users_authentification.component'

import {OrderFormProviderComponent} from './order-form-provider.component'
import {EnterInOrderFormProviderComponent} from './enter-in-order-form-provider.component';
import {PurchasingList} from './purchasing-list.component';
import {PurchasingOrder} from './purchasing-order.component';
import {OutOfWareList} from './out-of-ware-list.component';
import {OutOfWareOrder} from './out-of-ware-order.component';
import {OutInOrderFromOutOfWare} from './out-in-order-from-out-of-ware.component';

import {StockAvailibilityComponent} from './stock-availibility.component';

import {ImportItemsComponent} from './import-items.component';
import {LocationDocketComponent} from './location-docket.component';
import {LocationComponent} from './location.component';
import {ProductMofifyComponent} from './product-modify.component';

import {ActionsComponent} from './actions.component';

import {EntityComponent} from './entity.component';
import {OrderFromClientComponent} from './order-from-client.component';
import {ReturnFromClientComponent} from './return-from-client.component';
import {ReturnFromSupplierComponent} from './return-from-supplier.component';
import {RemainsToDeliverClientComponent} from './remains-to-deliver-client.component';
import {InventoryManagementComponent} from './inventory-management.component';
import {InventoriesListComponent} from './inventories-list.component';
import {InventoryComponent} from './inventory.component';
import {InventoryAnalysisComponent} from './inventory-analysis.component';
import {RemainsToDeliverSupplierComponent} from './remains-to-deliver-supplier.component';

import {StatisticComponent} from './statistic.component';

import {LocationManagerComponent} from './location-manager.component';

import {StockInitialComponent} from './stock-initial.component';
import {EnterStockComponent} from './enter-stock.component';
import {StockAssessmentComponent} from './stock-assessment.component';
import {TransferRequestComponent} from './transfer-request.component';
import {ReleaseOrderComponent} from './release-order.component';
import {ArticleReleaseComponent} from './article-release.component';
import {StockStatusComponent} from './stock-status.component';
import {LocationsComponent} from './locations.component';

import {EntrepotComponent} from './entrepot.component';

const routes: Routes = [
    // {path: '', redirectTo: '/dashboard', pathMatch: 'full'},
    {path: '', redirectTo: '/authentification', pathMatch: 'full'},

    {path: 'art', redirectTo: '', pathMatch: 'full'},
    {path: 'sudo-dashboard', redirectTo: '', pathMatch: 'full'},
    {path: 'stocks', redirectTo: '', pathMatch: 'full'},
    //{path: 'suppliers', redirectTo: '', pathMatch: 'full'},
    {path: 'stat', redirectTo: '', pathMatch: 'full'},
    {path: 'help', redirectTo: '', pathMatch: 'full'},
    {path: 'help', redirectTo: '', pathMatch: 'full'},
    {path: 'users', component: UsersComponent},
    {path: 'super-users', redirectTo: '', pathMatch: 'full'},

    {path: 'authentification', component: AuthentificationComponent},
    {path: 'admin', component: SuperUsersAuthentificationComponent},
    {path: 'dashboard', component: DashboardComponent},
    {path: 'product-insert', component: ProductInsertComponent},
    {path: 'products-category', component: ProductsCategoryComponent},
    {path: 'products-list', component: ProductsListComponent},
    {path: 'receip-stock', component: ReceipStock},
    {path: 'issue-stock', component: IssueStock},
    {path: 'products-abstract', component: ProductsAbstractComponent},
    {path: 'receipt-issue-stock', component: IssueReceiptStock},
    {path: 'receipt-stock_2', component: ReceiptStock2},
    {path: 'issue-stock_2', component: IssueStock2},
    {path: 'docket-history', component: Docket},
    {path: 'suppliers', component: EntityComponent},
    {path: 'admin/warehouse', component: SuperUsersComponent},
    {path: 'admin/stock-availibility', component: StockAvailibilityComponent},
    {path: 'stock-status', component: StockStatusComponent},
    {path: 'import-items', component: ImportItemsComponent},
    {path: 'location-management', component: LocationDocketComponent},
    {path: 'location', component: LocationComponent},
    {path: 'product-modification', component: ProductMofifyComponent},

    {path: 'actions', component: ActionsComponent},

    {path: 'bcf', component: OrderFormProviderComponent},
    //{path: 'enter-bcf', component: EnterInOrderFormProviderComponent},
    {path: 'enter-bcf', component: EnterStockComponent},
    
    {path: 'purchase', component: PurchasingList},
    {path: 'purchasing-list', component: PurchasingList},
    {path: 'purchasing-order', component: PurchasingOrder},
    {path: 'out-of-ware-list', component: OutOfWareList},
    {path: 'out-of-ware-order', component: OutOfWareOrder},
    {path: 'out-from-out-of-ware', component: OutInOrderFromOutOfWare},

    {path: 'clients', component: EntityComponent},
    {path: 'order-from-clients', component: OrderFromClientComponent},
    {path: 'return-from-clients', component: ReturnFromClientComponent},
    {path: 'return-from-suppliers', component: ReturnFromSupplierComponent},
    {path: 'remains-to-deliver', component: RemainsToDeliverClientComponent},
    {path: 'remains-to-deliver-supplier', component: RemainsToDeliverSupplierComponent},
    {path: 'inventories', component: InventoryManagementComponent},
    {path: 'inventory-capture', component: InventoryComponent},
    {path: 'inventory-analysis', component: InventoryAnalysisComponent},
    {path: 'inventory-reports', component: InventoriesListComponent},
    {path: 'statistics', component: StatisticComponent},

    {path: 'location-manager', component: LocationManagerComponent},
    {path: 'initial-stock', component: StockInitialComponent},
    {path: 'enter-stock', component: EnterStockComponent},

    {path: 'stock-assessment', component: StockAssessmentComponent},
    {path: 'transfer-request', component: TransferRequestComponent},
    {path: 'release-order/:motif', component: ReleaseOrderComponent},
    {path: 'article-release', component: ArticleReleaseComponent},

    {path: 'locations', component: LocationsComponent},
    {path: 'warehouses', component: EntrepotComponent},

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts